import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LogLevel, LoggerAbstractService } from 'bqx-logging';
import { UAParser } from 'ua-parser-js';
import { AppConfig } from './app.config';
import { UserInfoDetails } from './models/shared/shared-types';
import { AbstractDealAnalyticsService } from './services/deal-analytics/abstract-deal-analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit, OnInit {
  title = 'bqx-agent-ui';
  public get authorized(): boolean {
    const user = localStorage.getItem('client-user');
    return (window.location.pathname === '/logout' && user === null) ? false : true;
  }

  private parser = new UAParser();
  private result = this.parser.getResult();
  private startTime = 0;
  private endTime = 0;
  private details: UserInfoDetails = {
    userName: JSON.parse(localStorage.getItem('client-user'))?.Username,
    loadTime: 0,
    deviceType: this.result.device.type ?? "desktop",
    browserName: this.result.browser.name,
    browserVersion: this.result.browser.version,
    osName: this.result.os.name,
    osVersion: this.result.os.version
  };

  constructor(private loggerService: LoggerAbstractService, private dealAnalyticsService: AbstractDealAnalyticsService) {}

  ngAfterViewInit(): void {
    this.loadWalkMeScript();
  }

  ngOnInit(): void {
    if((window.performance.getEntries()[0] as PerformanceNavigationTiming).type !== 'reload') {
      sessionStorage.removeItem('app-uid-token');
      sessionStorage.removeItem('token_id');
    }

    if(window.performance.toJSON().navigation.type === 0) {   //  navigation.type of 0 is a page load, 1 is a reload
      this.pageLoadTime(0);
    }
 }

  private loadWalkMeScript() {
    const node = document.createElement('script');
    node.text = AppConfig.settings.walkMe.walkMeScript.toString();
    node.type = 'text/javascript';
    node.async = false;
    node.id = 'walkMeScript';
    document.getElementsByTagName('head')[0].appendChild(node);
    // TODO: add logging after authentication is revisited
    // this.loggerService.postLogData(LogLevel.Info, 'Loaded 3rd party walkMe script from walkMeScript code in config.json').subscribe(result => {
    //   this.logger.debug(result);
    // }, err => {
    //   this.logger.error(err);
    // });
  }

  private pageLoadTime(val: number) {
    if(val < 240) {   //  Kills this off after 240 calls (ie 2 minutes) to prevent infinite loop
      setTimeout( () => {
        if(window.performance.toJSON().timing.loadEventEnd) {
          this.startTime = window.performance.toJSON().timing.navigationStart;
          this.endTime = window.performance.toJSON().timing.loadEventEnd;
          this.details.loadTime = this.endTime - this.startTime;
          this.loggerService.postLogData(LogLevel.Info, 'User Info on Page Load', JSON.stringify(this.details));
        }
        else {
          this.pageLoadTime(val + 1);
        }
      }, 500);
    }
  }
}
